import { render } from "./SelectCard.vue?vue&type=template&id=95f2247a"
import script from "./SelectCard.vue?vue&type=script&lang=js"
export * from "./SelectCard.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SelectCard.vue?vue&type=style&index=0&id=95f2247a&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/home/circleci/project/frontend/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__